import Empty from '../empty/Empty'

import './video.css'

const BoxVideo = ({videos}) => {

      if(videos.data){

            return (
                  <div className="container">
                        <Empty text={`No Video Available`} />
                  </div>
            )
      }

      return (
            <div className="container video">
                  <div className="video_title">
                        <h3>{videos[0].title}</h3>
                  </div>
                  <div className="video_box">
                  <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${videos[0].id_video}`} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                  </div>
            </div>
      )
}

export default BoxVideo
